var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "px-10" }, [
      _c(
        "div",
        { staticClass: "termo-compromisso" },
        [
          !_vm.isReurb ? _c("termo-compromisso") : _vm._e(),
          _vm.isReurb ? _c("termo-compromisso-reurb") : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "container-checkbox" },
        [
          _c("el-checkbox", {
            attrs: { disabled: "disabled" },
            model: {
              value: _vm.confirmado,
              callback: function($$v) {
                _vm.confirmado = $$v
              },
              expression: "confirmado"
            }
          }),
          _c("span", { staticClass: "greenText" }, [
            _vm._v(_vm._s(_vm.termoAceito))
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65074732", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65074732","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesTermoCompromisso.vue
// module id = null
// module chunks = 